module.exports = __webpack_public_path__ + "img/ab13bdd.png";